import React from "react";
import { Link } from "gatsby";
import classnames from "classnames";
import Home from "./icons/home.svg";
import styles from "./Breadcrumb.module.scss";

export type BreadcrumbItem = {
  label: string;
  path?: string;
};

type Props = {
  items: BreadcrumbItem[];
};

const Breadcrumb = ({ items }: Props) => {
  return (
    <div className="spring">
      <nav>
        <ul className={classnames(styles["Breadcrumb"])}>
          <li
            className={classnames(
              styles["Breadcrumb__item"],
              styles["Breadcrumb__linkItem"],
              styles["Breadcrumb__homeItem"],
              {
                [styles["Breadcrumb__lastLinkItem"]]: items.length === 1
              }
            )}
          >
            <Link to="/">
              <img className={styles["icon"]} src={Home} alt="Homepage" />
            </Link>
          </li>

          {items.map((item, index, array) => {
            if (item.path) {
              return (
                <li
                  key={index}
                  className={classnames(
                    styles["Breadcrumb__item"],
                    styles["Breadcrumb__linkItem"],
                    {
                      [styles["Breadcrumb__lastLinkItem"]]:
                        index === array.length - 2
                    }
                  )}
                >
                  <Link to={item.path}>{item.label}</Link>
                </li>
              );
            } else {
              return (
                <li
                  key={index}
                  className={classnames(
                    styles["Breadcrumb__item"],
                    styles["Breadcrumb__labelItem"]
                  )}
                >
                  {item.label}
                </li>
              );
            }
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumb;
